import { NgModule } from '@angular/core';


import {CommonModule} from "@angular/common";
import {IntTableComponent} from "./int-table.component";
import {TableChildDirective} from "./table-child.directive";
import {IntTableBodyTdComponent} from "./int-table-body-td.component";

@NgModule({
  declarations: [
    IntTableComponent,
    TableChildDirective,
    IntTableBodyTdComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    IntTableComponent,
    TableChildDirective,
    IntTableBodyTdComponent
  ]
})
export class IntTableModule { }
